(function () {
  'use strict';

  var MQL = window.matchMedia('(max-width: 749px)');

  /* ── Viewer state ──────────────────────────────────────────── */
  var viewer = null;
  var vState = {
    open: false,
    images: [],
    current: 0,
    total: 0,
    galleryId: null,
    lastScrollY: 0,
    returnFocus: null,
  };

  /* ── Pinch / swipe trackers ────────────────────────────────── */
  var zoom = { scale: 1, panX: 0, panY: 0, initDist: 0, initScale: 1, pinching: false };
  var swipe = { startX: 0, startY: 0, curX: 0, dragging: false, horiz: null };
  var lastT = { x: 0, y: 0 };

  /* ── Per-gallery state ─────────────────────────────────────── */
  var galleries = {};

  /* ================================================================
     BUILD VIEWER  (once, appended to <body>)
  ================================================================ */
  function buildViewer() {
    if (document.getElementById('abs-viewer')) {
      viewer = document.getElementById('abs-viewer');
      return;
    }
    var v = document.createElement('div');
    v.id = 'abs-viewer';
    v.className = 'abs-viewer';
    v.setAttribute('role', 'dialog');
    v.setAttribute('aria-modal', 'true');
    v.setAttribute('aria-label', 'Produktbilder');
    v.setAttribute('aria-hidden', 'true');
    v.innerHTML =
      '<button class="abs-v-close" type="button" aria-label="Schließen">' +
        '<svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
          '<line x1="2" y1="2" x2="16" y2="16"/>' +
          '<line x1="16" y1="2" x2="2" y2="16"/>' +
        '</svg>' +
      '</button>' +
      '<div class="abs-v-stage">' +
        '<div class="abs-v-track" id="abs-v-track"></div>' +
      '</div>' +
      '<div class="abs-v-nav">' +
        '<div class="abs-v-pill">' +
          '<button class="abs-v-btn abs-v-prev" type="button" aria-label="Vorheriges Bild">' +
            '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
              '<polyline points="10 2 4 8 10 14"/>' +
            '</svg>' +
          '</button>' +
          '<span class="abs-v-counter" aria-live="polite" aria-atomic="true"></span>' +
          '<button class="abs-v-btn abs-v-next" type="button" aria-label="Nächstes Bild">' +
            '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
              '<polyline points="6 2 12 8 6 14"/>' +
            '</svg>' +
          '</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(v);
    viewer = v;

    v.querySelector('.abs-v-close').addEventListener('click', closeViewer);
    v.querySelector('.abs-v-prev').addEventListener('click', function () { viewerGo(vState.current - 1); });
    v.querySelector('.abs-v-next').addEventListener('click', function () { viewerGo(vState.current + 1); });

    document.addEventListener('keydown', function (e) {
      if (!vState.open) return;
      if (e.key === 'Escape') closeViewer();
      if (e.key === 'ArrowLeft') viewerGo(vState.current - 1);
      if (e.key === 'ArrowRight') viewerGo(vState.current + 1);
    });

    setupTouch();
  }

  /* ================================================================
     OPEN / CLOSE
  ================================================================ */
  function collectImages(sliderList) {
    var imgs = [];
    var slides = sliderList.querySelectorAll(':scope > li.slider__slide');
    slides.forEach(function (slide) {
      var img = slide.querySelector('.product__media img');
      if (!img) return;
      imgs.push({
        src: img.getAttribute('src') || img.src,
        srcset: img.getAttribute('srcset') || '',
        alt: img.getAttribute('alt') || '',
      });
    });
    return imgs;
  }

  function openViewer(galleryId, startIdx) {
    if (!viewer) buildViewer();
    var gs = galleries[galleryId];
    if (!gs) return;

    var imgs = collectImages(gs.sliderList);
    if (!imgs.length) return;

    vState.images = imgs;
    vState.total = imgs.length;
    vState.current = Math.max(0, Math.min(startIdx, imgs.length - 1));
    vState.galleryId = galleryId;

    /* Populate track */
    var track = document.getElementById('abs-v-track');
    track.innerHTML = '';
    imgs.forEach(function (d) {
      var slide = document.createElement('div');
      slide.className = 'abs-v-slide';
      var wrap = document.createElement('div');
      wrap.className = 'abs-v-imgwrap';
      var img = document.createElement('img');
      img.className = 'abs-v-img';
      img.src = d.src;
      if (d.srcset) img.srcset = d.srcset;
      img.alt = d.alt;
      img.draggable = false;
      wrap.appendChild(img);
      slide.appendChild(wrap);
      track.appendChild(slide);
    });

    resetAllZoom();
    positionTrack(false);
    updateNav();

    /* Lock body scroll (iOS-safe) */
    vState.lastScrollY = window.scrollY;
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + vState.lastScrollY + 'px';
    document.body.style.width = '100%';

    viewer.setAttribute('aria-hidden', 'false');
    viewer.classList.add('is-open');
    vState.open = true;
    var closeBtn = viewer.querySelector('.abs-v-close');
    if (closeBtn) closeBtn.focus();
  }

  function closeViewer() {
    if (!vState.open) return;
    viewer.classList.remove('is-open');
    viewer.setAttribute('aria-hidden', 'true');
    vState.open = false;

    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, vState.lastScrollY);

    if (vState.returnFocus) { vState.returnFocus.focus(); vState.returnFocus = null; }

    setTimeout(function () {
      if (!vState.open) {
        var track = document.getElementById('abs-v-track');
        if (track) track.innerHTML = '';
      }
    }, 350);
  }

  function viewerGo(idx) {
    if (idx < 0 || idx >= vState.total) return;
    resetCurrentZoom();
    vState.current = idx;
    positionTrack(true);
    updateNav();
    if (vState.galleryId) syncDot(vState.galleryId, vState.current);
  }

  function positionTrack(animate) {
    var track = document.getElementById('abs-v-track');
    if (!track) return;
    track.style.transition = animate ? 'transform 0.28s cubic-bezier(.4,0,.2,1)' : 'none';
    track.style.transform = 'translateX(-' + (vState.current * 100) + '%)';
    if (animate) setTimeout(function () { if (track) track.style.transition = 'none'; }, 300);
  }

  function updateNav() {
    viewer.querySelector('.abs-v-counter').textContent = (vState.current + 1) + ' / ' + vState.total;
    viewer.querySelector('.abs-v-prev').disabled = vState.current <= 0;
    viewer.querySelector('.abs-v-next').disabled = vState.current >= vState.total - 1;
  }

  /* ================================================================
     PINCH ZOOM + PAN + SWIPE
  ================================================================ */
  function tdist(t) {
    var dx = t[0].clientX - t[1].clientX, dy = t[0].clientY - t[1].clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function resetAllZoom() { zoom.scale = 1; zoom.panX = 0; zoom.panY = 0; applyZoom(); }
  function resetCurrentZoom() { zoom.scale = 1; zoom.panX = 0; zoom.panY = 0; applyZoom(); }

  function applyZoom() {
    var track = document.getElementById('abs-v-track');
    if (!track) return;
    var slide = track.children[vState.current];
    if (!slide) return;
    var wrap = slide.querySelector('.abs-v-imgwrap');
    if (!wrap) return;
    wrap.style.transform = 'translate(' + zoom.panX + 'px,' + zoom.panY + 'px) scale(' + zoom.scale + ')';
  }

  function setupTouch() {
    var stage = viewer.querySelector('.abs-v-stage');

    stage.addEventListener('touchstart', function (e) {
      var t = e.touches;
      if (t.length === 1) {
        swipe.startX = swipe.curX = t[0].clientX;
        swipe.startY = t[0].clientY;
        swipe.dragging = true;
        swipe.horiz = null;
        lastT.x = t[0].clientX;
        lastT.y = t[0].clientY;
        zoom.pinching = false;
      } else if (t.length === 2) {
        zoom.pinching = true;
        swipe.dragging = false;
        zoom.initDist = tdist(t);
        zoom.initScale = zoom.scale;
      }
    }, { passive: true });

    stage.addEventListener('touchmove', function (e) {
      var t = e.touches;

      if (zoom.pinching && t.length === 2) {
        e.preventDefault();
        var ns = zoom.initScale * (tdist(t) / zoom.initDist);
        zoom.scale = Math.max(1, Math.min(4, ns));
        applyZoom();
        return;
      }

      if (!swipe.dragging || t.length !== 1) return;
      swipe.curX = t[0].clientX;
      var dx = t[0].clientX - swipe.startX;
      var dy = t[0].clientY - swipe.startY;

      if (swipe.horiz === null && (Math.abs(dx) > 5 || Math.abs(dy) > 5)) {
        swipe.horiz = Math.abs(dx) > Math.abs(dy);
      }

      if (zoom.scale > 1) {
        /* Pan the zoomed image */
        e.preventDefault();
        zoom.panX += t[0].clientX - lastT.x;
        zoom.panY += t[0].clientY - lastT.y;
        applyZoom();
      } else if (swipe.horiz) {
        /* Drag the track */
        e.preventDefault();
        var track = document.getElementById('abs-v-track');
        if (track) {
          var pct = dx / track.offsetWidth * 100;
          var edge = (vState.current === 0 && dx > 0) || (vState.current === vState.total - 1 && dx < 0);
          if (edge) pct *= 0.25;
          track.style.transform = 'translateX(' + (-(vState.current * 100) + pct) + '%)';
        }
      }
      lastT.x = t[0].clientX;
      lastT.y = t[0].clientY;
    }, { passive: false });

    stage.addEventListener('touchend', function () {
      if (zoom.pinching) {
        zoom.pinching = false;
        if (zoom.scale < 1) { zoom.scale = 1; zoom.panX = 0; zoom.panY = 0; applyZoom(); }
        return;
      }
      if (!swipe.dragging) return;
      swipe.dragging = false;
      if (zoom.scale > 1 || !swipe.horiz) return;
      var dx = swipe.curX - swipe.startX;
      if (dx < -60 && vState.current < vState.total - 1) viewerGo(vState.current + 1);
      else if (dx > 60 && vState.current > 0) viewerGo(vState.current - 1);
      else positionTrack(true);
    }, { passive: true });
  }

  /* ================================================================
     DOTS
  ================================================================ */
  function syncDot(galleryId, idx) {
    var gs = galleries[galleryId];
    if (!gs || !gs.dotsEl) return;
    gs.dotsEl.querySelectorAll('.abs-pg-dot').forEach(function (d, i) {
      d.classList.toggle('is-active', i === idx);
    });
    gs.currentIdx = idx;
  }

  function rebuildDots(gs, n, activeIdx) {
    if (!gs.dotsEl) return;
    gs.dotsEl.innerHTML = '';
    for (var i = 0; i < n; i++) {
      var d = document.createElement('span');
      d.className = 'abs-pg-dot' + (i === activeIdx ? ' is-active' : '');
      gs.dotsEl.appendChild(d);
    }
  }

  /* ================================================================
     GALLERY INIT
  ================================================================ */
  function initGallery(galleryEl) {
    if (!MQL.matches) return;
    if (galleryEl._absInit) return;
    galleryEl._absInit = true;

    var galleryId = (galleryEl.id || '').replace('MediaGallery-', '');
    if (!galleryId) return;

    var sliderComp = galleryEl.querySelector('[id^="GalleryViewer-"]');
    var sliderList = galleryEl.querySelector('[id^="Slider-Gallery-"]');
    if (!sliderComp || !sliderList) return;

    var n = sliderList.querySelectorAll(':scope > li.slider__slide').length;

    var gs = {
      galleryEl: galleryEl,
      sliderComp: sliderComp,
      sliderList: sliderList,
      currentIdx: 0,
      dotsEl: null,
      zoomBtn: null,
    };
    galleries[galleryId] = gs;

    /* ── Zoom button ──────────────────────────────────────────── */
    var zBtn = document.createElement('button');
    zBtn.className = 'abs-pg-zoom';
    zBtn.type = 'button';
    zBtn.setAttribute('aria-label', 'Produktbild vergrößern');
    zBtn.innerHTML =
      '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
        '<circle cx="11" cy="11" r="8"/>' +
        '<line x1="21" y1="21" x2="16.65" y2="16.65"/>' +
        '<line x1="11" y1="8" x2="11" y2="14"/>' +
        '<line x1="8" y1="11" x2="14" y2="11"/>' +
      '</svg>';
    sliderComp.appendChild(zBtn);
    gs.zoomBtn = zBtn;

    /* ── Dots (only when >1 image) ────────────────────────────── */
    if (n >= 2) {
      var dotsEl = document.createElement('div');
      dotsEl.className = 'abs-pg-dots';
      dotsEl.setAttribute('aria-hidden', 'true');
      for (var i = 0; i < n; i++) {
        var dot = document.createElement('span');
        dot.className = 'abs-pg-dot' + (i === 0 ? ' is-active' : '');
        dotsEl.appendChild(dot);
      }
      /* Insert after sliderComp, before any thumbnail slider */
      var insertRef = sliderComp.nextElementSibling;
      if (insertRef) {
        galleryEl.insertBefore(dotsEl, insertRef);
      } else {
        galleryEl.appendChild(dotsEl);
      }
      gs.dotsEl = dotsEl;
    }

    /* ── Scroll → dot sync ────────────────────────────────────── */
    var raf = null;
    sliderList.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var w = sliderList.clientWidth;
        if (w <= 0) return;
        var idx = Math.round(sliderList.scrollLeft / w);
        var fresh = sliderList.querySelectorAll(':scope > li.slider__slide');
        idx = Math.max(0, Math.min(idx, fresh.length - 1));
        if (idx !== gs.currentIdx) syncDot(galleryId, idx);
        /* Gallery moved by code (colour change, initial position): keep the swipe
           start index in sync once the scroll has settled on a slide */
        if (!tState.active && fresh[idx] && Math.abs(sliderList.scrollLeft - fresh[idx].offsetLeft) < 2) targetIdx = idx;
      });
    }, { passive: true });

    /* ── slideChanged (from slider-component) ─────────────────── */
    sliderComp.addEventListener('slideChanged', function (e) {
      if (!e.detail || !e.detail.currentElement) return;
      var cur = e.detail.currentElement;
      var fresh = Array.from(sliderList.querySelectorAll(':scope > li.slider__slide'));
      var idx = fresh.indexOf(cur);
      if (idx >= 0) syncDot(galleryId, idx);
    });

    /* ── Touch swipe (real-device horizontal swiping) ─────────── */
    /* Uses touchstart/move/end directly so we can call e.preventDefault()
       on touchmove for confirmed-horizontal gestures, which is the only
       reliable way to prevent both page scroll AND native container scroll
       from racing against our manual scrollTo() call on real iOS/Android. */
    var tState = { active: false, startX: 0, startY: 0, horiz: null, swipeDone: false };
    var targetIdx = 0;

    function snapToSlide(idx) {
      var slides = sliderList.querySelectorAll(':scope > li.slider__slide');
      idx = Math.max(0, Math.min(slides.length - 1, idx));
      var slide = slides[idx];
      if (!slide) return;
      targetIdx = idx;
      sliderList.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      syncDot(galleryId, idx);
    }

    sliderList.addEventListener('touchstart', function (e) {
      if (!MQL.matches) return;
      tState.swipeDone = false;
      tState.active = true;
      tState.startX = e.touches[0].clientX;
      tState.startY = e.touches[0].clientY;
      tState.horiz = null;
    }, { passive: true });

    sliderList.addEventListener('touchmove', function (e) {
      if (!MQL.matches || !tState.active || e.touches.length !== 1) return;
      var dx = e.touches[0].clientX - tState.startX;
      var dy = e.touches[0].clientY - tState.startY;
      if (tState.horiz === null && (Math.abs(dx) > 5 || Math.abs(dy) > 5)) {
        tState.horiz = Math.abs(dx) >= Math.abs(dy);
      }
      /* Only prevent default for confirmed horizontal gestures so that
         vertical swipes still scroll the page natively */
      if (tState.horiz === true) {
        e.preventDefault();
      }
    }, { passive: false });

    sliderList.addEventListener('touchend', function (e) {
      if (!MQL.matches || !tState.active) return;
      tState.active = false;
      if (!tState.horiz) return;
      var dx = e.changedTouches[0].clientX - tState.startX;
      if (Math.abs(dx) < 40) return; /* tap, not swipe */
      tState.swipeDone = true;
      if (dx < 0 && targetIdx < n - 1) snapToSlide(targetIdx + 1);
      else if (dx > 0 && targetIdx > 0) snapToSlide(targetIdx - 1);
    }, { passive: true });

    /* ── Intercept taps → open viewer (capture phase) ─────────── */
    galleryEl.addEventListener('click', function (e) {
      if (!MQL.matches) return;
      /* Block any click that immediately follows a swipe gesture */
      if (tState.swipeDone) {
        tState.swipeDone = false;
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }
      var isZoom   = !!e.target.closest('.abs-pg-zoom');
      var isToggle = !!e.target.closest('.product__media-toggle');
      var isOpener = !!e.target.closest('modal-opener.product__modal-opener--image');
      if (!isZoom && !isToggle && !isOpener) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      vState.returnFocus = gs.zoomBtn;
      openViewer(galleryId, gs.currentIdx);
    }, true);

    /* ── Variant change sync ──────────────────────────────────── */
    var variantSub = (typeof window.subscribe === 'function' && typeof window.PUB_SUB_EVENTS !== 'undefined');
    if (variantSub) {
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, function () {
        /* Wait for Dawn to reorder slides (500 ms debounce in media-gallery.js) */
        setTimeout(function () {
          var fresh = sliderList.querySelectorAll(':scope > li.slider__slide');
          var newN = fresh.length;

          /* Determine active index from is-active class or scroll position */
          var activeSlide = sliderList.querySelector('.slider__slide.is-active');
          var idx = 0;
          if (activeSlide) {
            Array.from(fresh).forEach(function (s, i) { if (s === activeSlide) idx = i; });
          } else {
            var w = sliderList.clientWidth;
            if (w > 0) idx = Math.round(sliderList.scrollLeft / w);
          }
          idx = Math.max(0, Math.min(idx, newN - 1));

          /* Rebuild dots if count changed */
          var oldDotCount = gs.dotsEl ? gs.dotsEl.querySelectorAll('.abs-pg-dot').length : 0;
          if (gs.dotsEl && oldDotCount !== newN) rebuildDots(gs, newN, idx);

          syncDot(galleryId, idx);
        }, 600);
      });
    }
  }

  /* ================================================================
     BOOT
  ================================================================ */
  function boot() {
    if (!MQL.matches) return;
    buildViewer();
    document.querySelectorAll('media-gallery[id^="MediaGallery-"]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var g = e.target.querySelector('media-gallery[id^="MediaGallery-"]');
    if (g) { g._absInit = false; initGallery(g); }
  });
})();
